module.exports = __webpack_public_path__ + "static/media/external_2.d015ff77.jpg";